import React, { createContext, useContext, useEffect, useMemo, useRef, useState } from 'react';

const NewTicketsContext = createContext(null);

export const NewTicketsProvider = ({ children }) => {
	const [unassignedCount, setUnassignedCount] = useState(0);
	const [hasNewTickets, setHasNewTickets] = useState(false);
	const isMountedRef = useRef(false);
	const wsRef = useRef(null);
	const reconnectTimerRef = useRef(null);

	useEffect(() => {
		isMountedRef.current = true;
		return () => {
			isMountedRef.current = false;
		};
	}, []);

	useEffect(() => {
		const connect = () => {
			const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
			const ws = new WebSocket(`${protocol}://${window.location.host}/api/ws/unassigned-count`);
			wsRef.current = ws;

			ws.onmessage = (e) => {
				if (!isMountedRef.current) return;
				try {
					const data = JSON.parse(e.data);
					const count = Number(data.unassignedCount ?? 0);
					setUnassignedCount(count);
					setHasNewTickets(count > 0);
				} catch (_) {}
			};

			ws.onclose = () => {
				if (!isMountedRef.current) return;
				// Переподключение через 5 секунд
				reconnectTimerRef.current = setTimeout(connect, 5000);
			};

			ws.onerror = () => {
				ws.close();
			};
		};

		connect();

		return () => {
			isMountedRef.current = false;
			clearTimeout(reconnectTimerRef.current);
			wsRef.current?.close();
		};
	}, []);

	const value = useMemo(() => ({ hasNewTickets, newTicketsCount: unassignedCount }), [hasNewTickets, unassignedCount]);

	return (
		<NewTicketsContext.Provider value={value}>{children}</NewTicketsContext.Provider>
	);
};

export const useNewTickets = () => useContext(NewTicketsContext);
